import Model from "./abstract/Model";

export default class ContractTemplate extends Model {

    constructor(props) {
      super();

      this.initializeAttributes(props, {

      });
    }
}
